const CalendarIcon = ({
  size = 16,
  fill = '#4F4C4D',
  ...props
}: React.ComponentProps<'svg'> & { size?: number | string }) => {
  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1667 2.50065H14.3334V1.66732C14.3334 1.20898 13.9584 0.833984 13.5001 0.833984C13.0417 0.833984 12.6667 1.20898 12.6667 1.66732V2.50065H4.33342V1.66732C4.33342 1.20898 3.95841 0.833984 3.50008 0.833984C3.04175 0.833984 2.66675 1.20898 2.66675 1.66732V2.50065H1.83341C0.916748 2.50065 0.166748 3.25065 0.166748 4.16732V17.5006C0.166748 18.4173 0.916748 19.1673 1.83341 19.1673H15.1667C16.0834 19.1673 16.8334 18.4173 16.8334 17.5006V4.16732C16.8334 3.25065 16.0834 2.50065 15.1667 2.50065ZM14.3334 17.5006H2.66675C2.20841 17.5006 1.83341 17.1257 1.83341 16.6673V6.66732H15.1667V16.6673C15.1667 17.1257 14.7917 17.5006 14.3334 17.5006Z"
        fill={fill}
      />
    </svg>
  );
};

export default CalendarIcon;
